import { Link } from "react-router-dom";
import { SiteHeader, SiteFooter } from "../components/SiteLayout";
import { LEGAL } from "../lib/legal";
import SEO from "../components/SEO";

export default function Cookies() {
  const openCookiePrefs = () => {
    if (typeof window !== "undefined" && window.__openCookieBanner) window.__openCookieBanner();
  };
  return (
    <div className="min-h-screen bg-stone-50">
      <SEO title="Política de Cookies" description="Información sobre el uso de cookies en fmsubastas.com conforme al art. 22.2 LSSI-CE y la Guía AEPD." path="/politica-cookies" />
      <SiteHeader />
      <article className="max-w-3xl mx-auto px-6 py-14 prose-fm">
        <div className="text-[10px] tracking-[0.3em] uppercase font-bold text-[#E0651F] mb-3">Legal</div>
        <h1 className="font-display text-4xl sm:text-5xl font-black tracking-tight text-[#2d1f1a] mb-8">Política de Cookies</h1>

        <P>El sitio web <strong>{LEGAL.domain}</strong> utiliza cookies y tecnologías similares conforme a lo establecido en el art. 22.2 de la Ley 34/2002 (LSSI-CE), la Guía sobre el uso de cookies de la <strong>AEPD</strong> y el Reglamento (UE) 2016/679.</P>

        <H2>1. ¿Qué son las cookies?</H2>
        <P>Las cookies son pequeños archivos de texto que se descargan en el dispositivo del Usuario al acceder a determinadas páginas web, y permiten almacenar y recuperar información sobre la navegación.</P>

        <H2>2. Tipos de cookies que utilizamos</H2>

        <h3 className="font-display font-black text-lg text-[#2d1f1a] mt-6 mb-3">2.1. Cookies técnicas (exentas de consentimiento)</h3>
        <P>Necesarias para el funcionamiento del sitio. No requieren consentimiento conforme a la Guía de la AEPD.</P>
        <CookieTable rows={[
          ["access_token", LEGAL.domain, "Sesión", "Mantiene la sesión iniciada del administrador. Solo se establece tras login en /admin/login."],
          ["fm_cookie_consent", LEGAL.domain, "12 meses", "Almacena las preferencias de consentimiento del Usuario respecto a las distintas categorías de cookies."],
        ]} />

        <h3 className="font-display font-black text-lg text-[#2d1f1a] mt-8 mb-3">2.2. Cookies analíticas (requieren consentimiento)</h3>
        <P>Permiten el seguimiento y análisis del comportamiento de los usuarios en la web, de forma anónima o seudonimizada, para mejorar los servicios.</P>
        <CookieTable rows={[
          ["_ga, _ga_*", "Google LLC (.google-analytics.com)", "2 años / 24 h", "Google Analytics — distingue usuarios y sesiones únicas con fines estadísticos."],
          ["_gid", "Google LLC", "24 horas", "Distingue usuarios para estadísticas (Google Analytics 4)."],
        ]} />

        <h3 className="font-display font-black text-lg text-[#2d1f1a] mt-8 mb-3">2.3. Cookies de marketing (requieren consentimiento)</h3>
        <P>Permiten realizar seguimiento del Usuario para mostrar publicidad relevante en otros sitios o medir la eficacia de campañas. Solo se cargarán si el Usuario otorga su consentimiento expreso. Actualmente NO se utilizan, pero se reservan para futuras campañas (Meta Pixel, Google Ads, etc.).</P>

        <H2>3. Cookies de terceros</H2>
        <P>Algunas funcionalidades del sitio incluyen contenido o servicios de terceros (Stripe, Calendly, WhatsApp, Resend) que pueden establecer sus propias cookies. La gestión de dichas cookies corresponde a sus respectivos titulares conforme a sus propias políticas.</P>

        <H2>4. Gestión del consentimiento</H2>
        <P>Al acceder por primera vez al sitio, se muestra un banner que permite:</P>
        <ul className="list-disc pl-6 space-y-1 text-stone-700 mb-4">
          <li>Aceptar todas las cookies.</li>
          <li>Rechazar todas las cookies no esenciales.</li>
          <li>Configurar las preferencias por categoría (técnicas / analíticas / marketing).</li>
        </ul>
        <P>El Usuario puede modificar sus preferencias en cualquier momento haciendo clic en el siguiente botón:</P>
        <button onClick={openCookiePrefs}
          className="inline-flex items-center gap-2 bg-[#E0651F] hover:bg-[#2d1f1a] text-white px-5 py-3 text-xs tracking-[0.18em] uppercase font-bold rounded-sm transition-colors my-4"
          data-testid="open-cookie-prefs">
          Configurar preferencias de cookies
        </button>

        <H2>5. Cómo desactivar cookies en su navegador</H2>
        <P>Adicionalmente, puede configurar su navegador para bloquear o eliminar cookies:</P>
        <ul className="list-disc pl-6 space-y-1 text-stone-700 mb-4">
          <li><a href="https://support.google.com/chrome/answer/95647" target="_blank" rel="noopener noreferrer">Chrome</a></li>
          <li><a href="https://support.mozilla.org/es/kb/habilitar-y-deshabilitar-cookies-sitios-web-rastrear-preferencias" target="_blank" rel="noopener noreferrer">Firefox</a></li>
          <li><a href="https://support.apple.com/es-es/HT201265" target="_blank" rel="noopener noreferrer">Safari</a></li>
          <li><a href="https://support.microsoft.com/es-es/microsoft-edge/eliminar-las-cookies-en-microsoft-edge-63947406-40ac-c3b8-57b9-2a946a29ae09" target="_blank" rel="noopener noreferrer">Microsoft Edge</a></li>
        </ul>
        <P>El bloqueo de las cookies técnicas puede afectar al correcto funcionamiento del sitio (por ejemplo, no podrá iniciar sesión en el panel admin).</P>

        <H2>6. Actualizaciones</H2>
        <P>Esta Política se revisa periódicamente. Cualquier modificación se notificará mostrando de nuevo el banner de consentimiento si afecta a categorías ya configuradas.</P>

        <p className="text-xs text-stone-500 mt-12">Última actualización: {LEGAL.lastUpdated}</p>
      </article>
      <SiteFooter />
      <ProseStyle />
    </div>
  );
}

function H2({ children }) { return <h2 className="font-display text-2xl font-black tracking-tight text-[#2d1f1a] mt-12 mb-4">{children}</h2>; }
function P({ children }) { return <p className="text-stone-700 leading-relaxed mb-4">{children}</p>; }
function CookieTable({ rows }) {
  return (
    <div className="overflow-x-auto my-4">
      <table className="w-full text-sm border border-stone-200 bg-white">
        <thead>
          <tr className="bg-stone-100">
            <th className="text-left px-3 py-2 text-[10px] uppercase tracking-[0.2em] font-bold text-stone-600">Cookie</th>
            <th className="text-left px-3 py-2 text-[10px] uppercase tracking-[0.2em] font-bold text-stone-600">Proveedor</th>
            <th className="text-left px-3 py-2 text-[10px] uppercase tracking-[0.2em] font-bold text-stone-600">Duración</th>
            <th className="text-left px-3 py-2 text-[10px] uppercase tracking-[0.2em] font-bold text-stone-600">Finalidad</th>
          </tr>
        </thead>
        <tbody>
          {rows.map(([c, p, d, f]) => (
            <tr key={c} className="border-t border-stone-200 align-top">
              <td className="px-3 py-2 font-mono text-xs text-[#2d1f1a]">{c}</td>
              <td className="px-3 py-2 text-stone-700">{p}</td>
              <td className="px-3 py-2 text-stone-700">{d}</td>
              <td className="px-3 py-2 text-stone-700">{f}</td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}
function ProseStyle() {
  return <style>{`.prose-fm a{color:#E0651F;text-decoration:underline}.prose-fm a:hover{color:#2d1f1a}`}</style>;
}
